import React, { useEffect, useState } from 'react'
import { Nivel2Screen } from './Nivel2Screen'

export const Nivel1Screen = ({ data }) => {

    const [state, setState] = useState([]);
    useEffect(() => {
        if (data === undefined || data == null || data.lenght === 0) {
            setState([]);
            return;
        }

        var array = data.reduce(function (groups, item) {
            var val = item['nivel1']
            groups[val] = groups[val] || val;
            return groups;
        }, {});
        setState(Object.values(array));
    }, [data])
    if (state.length == 0) return <div></div>

    return state.map(item => (
        <>
            {/* <tr>
                <td colSpan={10} className='nivel1'>{item}</td>
            </tr> */}
            <Nivel2Screen data={data} nivel1={item} group={item} />
            <tr>
                {/* <td className={10}>Total {item}</td> */}
            </tr>
        </>
    ))
}
